import React from "react";
import { Button } from "@mui/material";
import { cssProperties } from "../../utils/commonCssProperties";
import { MdOutlineArrowBack } from "react-icons/md";

export default function BackButton({ handleBack }) {

    return (
        <Button
            type='button'
            disableElevation
            variant="contained"
            sx={{
                borderRadius: '40px',
                padding: '0px 24px',
                height: '40px',
                backgroundColor: `${cssProperties?.buttonbgcolor?.back}`,
                fontSize: '14px',
                fontWeight: '600',
                lineHeight: '15.4px',
                letterSpacing: '0.32px',
                boxShadow: 'none',
                color: `${cssProperties?.color?.gray}`,
                border: '1px solid transparent',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                '&:hover': {
                    backgroundColor: `${cssProperties?.buttonbgcolor?.back}`,
                    boxShadow: 'none',
                    color: `${cssProperties?.color?.gray}`,
                }
            }}
            onClick={handleBack}
        >
            <MdOutlineArrowBack size={24} /> Back
        </Button>
    )
}